import { motion } from "framer-motion";
import { ArrowDown, Clock, Sparkles, ShieldCheck } from "lucide-react";

export const Hero = ({ onStart, onBook }) => {
  return (
    <section className="relative overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 -z-10">
        <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-accent/10 blur-3xl" />
        <div className="absolute top-40 -left-24 h-80 w-80 rounded-full bg-primary/10 blur-3xl" />
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-16 md:pt-24 pb-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <span className="inline-flex items-center gap-2 text-sm font-medium bg-card border border-border rounded-full px-4 py-1.5 mb-6 shadow-sm">
            <Sparkles className="h-4 w-4 text-accent" />
            Hecho para dueños ocupados, no para técnicos
          </span>

          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05]">
            Identifica el trabajo aburrido{" "}
            <span className="text-accent">y deja que la IA lo haga por ti.</span>
          </h1>

          <p className="text-lg text-muted-foreground mt-6 max-w-xl leading-relaxed">
            Dinos en qué se te va el día. En segundos te mostramos qué herramientas sencillas
            podrían ahorrarte horas y cuánto podrían costarte.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 mt-8">
            <button
              onClick={onStart}
              data-testid="hero-start-btn"
              className="inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-8 py-4 rounded-full font-semibold text-base hover:bg-primary/90 transition-colors shadow-sm"
            >
              ¿Qué puedo automatizar? <ArrowDown className="h-4 w-4" />
            </button>
            <button
              onClick={onBook}
              data-testid="hero-book-btn"
              className="inline-flex items-center justify-center gap-2 bg-card border border-border px-8 py-4 rounded-full font-semibold text-base hover:border-primary/30 transition-colors"
            >
              Agenda una llamada gratis
            </button>
          </div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 mt-8 text-sm text-muted-foreground">
            <span className="inline-flex items-center gap-1.5">
              <Clock className="h-4 w-4 text-primary" /> Resultados en 3 clics
            </span>
            <span className="inline-flex items-center gap-1.5">
              <ShieldCheck className="h-4 w-4 text-primary" /> Sin registro, sin tecnicismos
            </span>
            <span className="inline-flex items-center gap-1.5">
              <Sparkles className="h-4 w-4 text-primary" /> Explorar es gratis
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
